import useResource from 'app/hooks/useResource';

import {
  getPurchases,
  setPurchaseParams
} from 'app/actions/purchases';

import {
  purchases as resource
} from 'app/resources';

const usePurchases = () => {
  return useResource({
    resource,
    getResource: getPurchases,
    setResourceParams: setPurchaseParams
  });
}

export default usePurchases;
